import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  resendVerification: {
    id: 'studio.EX+XpL',
    defaultMessage: 'Resend verification email',
  },
  resendVerificationSent: {
    id: 'studio.CwtqIN',
    defaultMessage: 'Resent verification email',
  },
  resendVerificationError: {
    id: 'studio.DD5lQj',
    defaultMessage: 'Something went wrong when sending the verification email.',
  },
});
